module.exports = {
  emailId: 'Please ensure to use a preconfigured one',
  emailBCC: 'Email addresses that receive orders',
  companyName: 'Company Name Goes Here',
  companyEmail: 'Email contact for the compmany',
  phone: 'Phone number including country code',
  companyCountry: 'Country for the company',
  companyTown: 'Town/City for the company',
  companyLocality: 'Locality for the company',
  companyPostal: 'Postal Code for the company',
  paymentTypes: 'Select Payment Types',
  pricingGroups: 'Select Pricing Groups',
  backupInterval: 'Backup Interval should be between 3 and 168 hours',
}


// WEBPACK FOOTER //
// ./src/lang/en/placeholders.js